import { SnackbarProvider } from 'notistack';

import { ReactNode } from 'react';

function Snackbar({ children }: { children: ReactNode }) {
  return <SnackbarProvider>{children}</SnackbarProvider>;
}

export default Snackbar;
